import React from 'react'
import { ENGINE_URL } from './constants'
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
//require('es6-promise').polyfill();
//require('isomorphic-fetch');
//require('whatwg-fetch');

export const dataContext = React.createContext()

export const allTypes = [{ value: 'number', name: 'Число' },
{ value: 'text', name: 'Текст' },
{ value: 'date', name: 'Дата' },
{ value: 'Const', name: localestr('Налаштування'), edit: 'sysConst_list', caption_edit: localestr('Налаштування') },
{ value: 'catUsers', name: localestr('Користувачі системи'), edit: 'catUsers_edit', caption_edit: localestr('Користувач') },
{ value: 'catDepartments', name: localestr('Підрозділи'), edit: 'catDepartments_list', caption_edit: localestr('Підрозділ') },
{ value: 'catDevices', name: localestr('Обладнання'), edit: 'catDevices_list', caption_edit: localestr('Обладнання') },
{ value: 'catDiscounts', name: localestr('Знижки/Клієнти'), edit: 'catDiscounts_edit', caption_edit: localestr('Знижка/Клієнт') },
{ value: 'catGoods', name: localestr('Товари'), edit: 'catGoods_edit', caption_edit: localestr('Товар') },
{ value: 'fldGoods', name: localestr('Папки'), edit: 'fldGoods_edit', caption_edit: localestr('Папка товар') },
{ value: 'catHalls', name: localestr('Зали'), edit: 'catHalls_edit', caption_edit: localestr('Зал') },
{ value: 'catTables', name: localestr('Столи'), edit: 'catTables_list', caption_edit: localestr('Стіл') },
{ value: 'catCounterparties', name: localestr('Контрагенти'), edit: 'catCounterparties_edit', caption_edit: localestr('Контрагент') },
{ value: 'fldCounterparties', name: localestr('Папки'), edit: 'fldGoods_edit', caption_edit: localestr('Папка контрагент') },
{ value: 'catArticles', name: localestr('Статті руху'), edit: 'catArticles_list', caption_edit: localestr('Статті руху') },
//                        {value:'catRooms',name:'Номерний фонд'},
{ value: 'docSupply', name: localestr('Журнал поступлень'), edit: 'docSupply_edit', caption_edit: localestr('Поступлення') },
{ value: 'docReject', name: localestr('Журнал повернень'), edit: 'docReject_edit', caption_edit: localestr('Повернення') },
{ value: 'docExpence', name: localestr('Журнал списань'), edit: 'docExpence_edit', caption_edit: localestr('Списання') },
{ value: 'docTransfer', name: localestr('Журнал переміщень'), edit: 'docTransfer_edit', caption_edit: localestr('Переміщення') },
{ value: 'docSurplus', name: localestr('Журнал оприбуткувань'), edit: 'docSurplus_edit', caption_edit: localestr('Оприбуткування') },
{ value: 'docCalculation', name: localestr('Калькуляції'), edit: 'docCalculation_edit', caption_edit: localestr('Калькуляція') },
{ value: 'docProduction', name: localestr('Виробництво'), edit: 'docProduction_edit', caption_edit: localestr('Виробництво') },
{ value: 'docRevision', name: localestr('Журнал інвентаризацій'), edit: 'docRevision_edit', caption_edit: localestr('Інвентаризація') },
{ value: 'docOrder', name: localestr('Журнал продаж'), edit: 'docOrder_edit', caption_edit: localestr('Замовлення') },
{ value: 'docStatement', name: localestr('Касова виписка'), edit: 'docStatement_edit', caption_edit: localestr('Ордер') },
{ value: 'docDebtadjust', name: localestr('Коригування боргів'), edit: 'docDebtadjust_edit', caption_edit: localestr('Коригування боргів') },
{ value: 'docCashadjust', name: localestr('Коригування коштів'), edit: 'docCashadjust_edit', caption_edit: localestr('Коригування коштів') },
{ value: 'docBonusadjust', name: localestr('Коригування бонусів'), edit: 'docBonusadjust_edit', caption_edit: localestr('Коригування бонусів') },
{ value: 'docRefillCert', name: localestr('Поповнення сертифікатів'), edit: 'docRefillCert_edit', caption_edit: localestr('Поповнення') },
{ value: 'docNullifyCert', name: localestr('Списання сертифікатів'), edit: 'docNullifyCert_edit', caption_edit: localestr('Списання') },
{ value: 'docSalary', name: localestr('Зарплата'), edit: 'docSalary_edit', caption_edit: localestr('Зарплата') },
{ value: 'docPayment', name: localestr('Виплата'), edit: 'docPayment_edit', caption_edit: localestr('Виплата') },
{ value: 'docConversion', name: localestr('Журнал переробки'), edit: 'docConversion_edit', caption_edit: localestr('Переробка') },
{ value: 'selYN', name: 'Перелік Так/Ні' }]

export const allAllergens = [{ name: 'глютен або його сліди', idx: 'GL' },
{ name: 'лактоза', idx: 'LAC' },
{ name: 'фруктоза', idx: 'FRU' },
{ name: 'злакові продукти', idx: 'W' },
{ name: 'ракоподібні продукти', idx: 'C' },
{ name: 'яйця', idx: 'E' },
{ name: 'риба', idx: 'F' },
{ name: 'арахіс', idx: 'PN' },
{ name: 'соєві боби', idx: 'S' },
{ name: 'молочні продукти', idx: 'M' },
{ name: 'горіхи', idx: 'N' },
{ name: 'селера', idx: 'CEL' },
{ name: 'гірчиця', idx: 'MUS' },
{ name: 'кунжут', idx: 'SE' },
{ name: 'люпін', idx: 'L' },
{ name: 'молюски', idx: 'MO' }]

export function localestr(val, lang = 'ua') {
  return val
}

const units = {
  '1': 'шт',
  '2': 'кг',
  '3': 'л',
  '4': 'пач',
  '5': 'м',
  '6': 'грн',
  '7': 'год',
  '8': 'пор',
  '9': 'пляш',
  '10': 'г',
  '11': 'кг',
  '12': 'кКал',
}

export function get_object_types() {
  const types = allTypes.filter(el => el.edit)
  return types.map(el => ({ value: el.value, name: el.caption_edit }))
}

export function load(data = {}, func = () => { }) {
  const controller = new AbortController()
  const id = setTimeout(() => controller.abort(), 6000)
  fetch(ENGINE_URL, {
    signal: controller.signal,
    method: 'post',
    // mode: 'cors', 
    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
    credentials: 'include',
    body: data
  })
    .then(
      function (response) {
        clearTimeout(id)
        if (response.status !== 200) {
          const pos = data.indexOf('data=')
          if (pos !== -1) {
            //const newData=data.slice(pos+5)
            //func({status:'OffLine',key:data.slice(7,pos-1),data:JSON.parse(newData)})  
            func({ status: 'error', msg: localestr('Відсутнє з\'єднання') })
          } else {
            //func({status:'OffLine',key:data.slice(7)})  
            func({ status: 'error', msg: localestr('Відсутнє з\'єднання') })
          }
          return
        }
        response.json().then(function (d) {
          func(d)
        })
      }
    )
    .catch(function (err) {
      clearTimeout(id)
      const pos = data.indexOf('data=')
      if (pos !== -1) {
        //const newData=data.slice(pos+5)
        //func({status:'OffLine',key:data.slice(7,pos-1),data:JSON.parse(newData)})  
        func({ status: 'error', msg: localestr('Відсутнє з\'єднання') })
      } else {
        //func({status:'OffLine',key:data.slice(7)})  
        func({ status: 'error', msg: localestr('Відсутнє з\'єднання') })
      }
    })
}

export function loadfrm(data, func = () => { }) {
  fetch(ENGINE_URL, { // Your POST endpoint
    method: 'post',
    mode: 'no-cors', //це удалити
    headers: { "Accept": "application/json", "type": "formData" },
    credentials: 'include',
    body: data // This is your file object
  }).then(
    response => {
      if (response.status !== 200) {
        func({ status: 'error', msg: localestr('Відсутнє з\'єднання') + ' con' + response.status })
        return
      }
      response.json().then(d => func(d))
    }
  ).catch(err => func({ status: 'error', msg: localestr('Відсутнє з\'єднання') + ' err' + err }))
}

export function loaddat(data, func = () => { }) {
  fetch(ENGINE_URL, { // Your POST endpoint
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
    credentials: 'include',
    body: data // This is your file object
  }).then(
    response => {
      if (response.status !== 200) {
        func({ status: 'error', msg: localestr('Відсутнє з\'єднання') + ' con' + response.status })
        return
      }
      response.json().then(d => func(d))
    }
  ).catch(err => func({ status: 'error', msg: localestr('Відсутнє з\'єднання') + ' err' + err }))
}

export function uid() {
  return '_' + Math.random().toString(36).substring(2, 9)
}

export function isNumeric(value) {
  return !isNaN(value - parseFloat(value));
}

export function toText(val) {
  if (val === null) return ''
  if (val === undefined) return ''
  if (typeof val === 'object') {
    if (toString.call(val) === '[object Date]') return val.toLocaleDateString()
    else if (val.name === 'icon') return <img className='ico' src={val.src} alt={''} />
    else if (val.name === 'color') return <div style={{ width: '100%', height: '100%', backgroundColor: val.src }} />
    else if (val.obj_type === 'catGoods') return (val.id ? val.id + ' ' : '') + val.name
    else if (Array.isArray(val)) {
      let ret = ''
      val.forEach(el => ret += ',' + (el.name || el.id || ''))
      return ret.substring(1)
    }
    else return val.name
    //else return (val.id?val.id+' ':'')+val.name
  }
  else if (typeof val === 'string') {
    //console.log(val)
    //if (val.substring(10, 11)==='T' && val.substring(13, 14)===':') return new Date(val).toLocaleDateString()
    if (val.substring(10, 11) === 'T' && val.substring(13, 14) === ':') return new Date(val).toLocaleString()
    if (val.substring(4, 5) === '-' && val.substring(7, 8) === '-' && val.length === 10) return new Date(val).toLocaleDateString()
    if (val.substring(4, 5) === '-' && val.substring(7, 8) === '-') return new Date(val).toLocaleString()
    //else if(isNumeric(val)) return val*1
    else return val
  }
  else return val
}

export function strPeriod(from, to) {
  const b = beginMn(from)
  const e = endMn(to)
  let is_b = false
  let is_e = false
  const b_m = from.getMonth()
  const e_m = to.getMonth()
  if (from.getDate() === b.getDate()) is_b = true
  if (to.getDate() === e.getDate()) is_e = true
  const mn = [localestr('січень'), localestr('лютий'), localestr('березень'), localestr('квітень'), localestr('травень'), localestr('червень'),
  localestr('липень'), localestr('серпень'), localestr('вересень'), localestr('жовтень'), localestr('листопад'), localestr('грудень')]
  if (is_b && is_e && b_m === e_m) return mn[b_m] + " " + from.getFullYear()
  if (is_b && is_e) return mn[b_m] + "-" + mn[e_m] + " " + ("" + to.getFullYear()).substring(2)
  if (from.getDate() === to.getDate() && from.getMonth() === to.getMonth() && from.getFullYear() === to.getFullYear()) return toText(from)
  return toText(from) + '-' + toText(to)
}

export function validDate(val) {
  let arrD = toString(val).split('.')
  arrD[1] -= 1
  const d = new Date(arrD[2], arrD[1], arrD[0])
  if ((d.getFullYear() === arrD[2]) && (d.getMonth() === arrD[1]) && (d.getDate() === arrD[0])) return true
  else return false
}

export function getIrgValue(date, irg) {
  if (!irg) return undefined
  let dat = date
  if (isValidDate(date)) dat = date.toISOString().substring(0, 20)
  let newVal
  for (let i = 0; i < irg.length; i++) {
    if (irg[i].date <= dat) newVal = parseFloat(irg[i].value || 0)
    else break
  }
  return newVal
}

export function getIrgValueLast(date, irg) {
  if (!irg) return undefined
  let dat = date
  if (isValidDate(date)) dat = date.toISOString().substring(0, 20)
  let newVal
  for (let i = 0; i < irg.length; i++) {
    if (irg[i].date < dat) newVal = parseFloat(irg[i].value || 0)
    else break
  }
  return newVal
}

export function isValidDate(d) {
  return d instanceof Date && !isNaN(d)
}

export function typeToText(type, op = 1) {
  let idx = allTypes.findIndex(el => el.value === type)
  if (idx !== -1) {
    if (op === 1) return allTypes[idx].caption_edit
    return allTypes[idx].name
  }
  return type
}

export function itemToText(val) {
  if (typeof val !== 'object') return val
  if (val.type === 'sysLog' || (val.obj_type && val.obj_type === 'sysLog')) return localestr('Журнал подій')
  else if (val.obj_type && val.obj_type.substring(0, 3) === 'doc') return typeToText(val.obj_type) + ' №' + val.id + ' (' + val.date.substr(0, 10) + ')'
  else if (val.obj_type && val.obj_type.substring(0, 3) === 'cat') return typeToText(val.obj_type) + ' ' + val.id + '-' + val.name
  else if (val.type.substring(0, 3) === 'doc') return typeToText(val.type) + ' №' + val.id + ' (' + val.date.substr(0, 10) + ')'
  else if (val.type.substring(0, 3) === 'cat') return typeToText(val.type) + ' ' + val.id + '-' + val.name
  else if (val.type.substring(0, 3) === 'fld' || (val.obj_type && val.obj_type.substring(0, 3) === 'fld')) return localestr('Папка') + ' ' + val.id + '-' + val.name
}

export function beginMn(d) {
  let ret = new Date(d)
  ret.setDate(1)
  ret.setHours(0, 0, 0, 0)
  return ret
}

export function beginYr(d) {
  let ret = new Date(d)
  ret.setMonth(0, 1)
  ret.setHours(0, 0, 0, 0)
  return ret
}

export function endMn(d) {
  let ret = new Date(d)
  ret.setDate(1)
  ret.setMonth(ret.getMonth() + 1)
  ret.setHours(0, 0, 0, 0)
  return (new Date(ret - 1))
}

export function inputFrom(from_type, to_type, data) {
  const id = parseInt(data.id)
  delete data.id
  data.currentCol = -1
  data.edit = true
  data.posted = 0
  if (data.table) for (let i = 0; i < data.table.length; i++) { delete data.table[i].id; data.table[i].edit = true }
  data.date = (new Date()).toISOString().substring(0, 19) + 'Z'
  if (from_type === 'docSupply') {
    delete data.in_num
    delete data.in_date
    if (to_type === 'docStatement') {
      delete data.table
      data.operation = '1'
      data.corespond = data.counterpartie
    }
    data.docum = { pid: 1100000000 + id, id: id, doc_type: from_type, date: data.date }
  } else if (from_type === 'docTransfer') {
    data.department = data.dep_to
    data.docum = { pid: 1300000000 + id, id: id, doc_type: from_type, date: data.date }
    if (to_type === 'docRevision') if (data.table) for (let i = 0; i < data.table.length; i++) data.table[i].qtt_f = data.table[i].qtt
  }
  else if (from_type === 'docReject') {
    data.docum = { pid: 1200000000 + id, id: id, doc_type: from_type, date: data.date }
  }
  else if (from_type === 'docSurplus') {
    data.docum = { pid: 1500000000 + id, id: id, doc_type: from_type, date: data.date }
  }
  if (from_type === 'docReject' && to_type === 'docStatement') {
    delete data.table
    data.operation = '2'
    data.corespond = data.counterpartie
  }
  if (to_type === 'docTransfer') { data.dep_from = data.department; data.dep_to = null }
  return data
}

export function validate_ex_mark(data) {
  let ret = ''
  for (const symbol of data) {
    const char_code = symbol.charCodeAt(0)
    if (char_code < 91) ret += symbol
    else if (char_code < 123) ret += String.fromCharCode(char_code - 32)
    else {
      const arr = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ']
      const arr1 = [...'ФИСВУАПРШОЛДЬТЩЗЙКЫЕГМЦЧНЯ']
      const arr2 = [...'ФИСВУАПРШОЛДЬТЩЗЙКІЕГМЦЧНЯ']
      let idx = arr1.findIndex(el => el === symbol)
      if (idx === -1) idx = arr2.findIndex(el => el === symbol)
      if (idx !== -1) ret += arr[idx]
    }
  }
  return ret
}

export function filter_fn(item, filter) {
  let ret = true
  for (let k in filter) {
    //console.log(filter[k].dataId)
    const val1 = item[filter[k].dataId] || null
    const val2 = filter[k].value || null
    const comp = filter[k].compare
    const dataId = filter[k].typeVal
    if (comp === '=') {
      if (dataId.substring(0, 3) === 'sel') ret = val1.value === val2 || val1 === val2 //value
      else if (dataId.substring(0, 3) === 'cat' && (filter[k].dataId.includes('.'))) {
        const par = filter[k].dataId.split('.')
        const arr = item[par[0]] || []
        const idx = arr.findIndex(el => el[par[1]] === val2.id)
        ret = idx !== -1
      }
      else if (dataId.substring(0, 3) === 'cat' && (!val1 || !val2)) ret = false //id
      else if (dataId.substring(0, 3) === 'cat') ret = val1.id === val2.id //id
      else if (dataId === 'text') ret = val1.toLowerCase() === val2.toLowerCase()
      else if (dataId === 'number' || dataId === 'number1' || dataId === 'number2' || dataId === 'number3') ret = parseFloat(val1 || 0) === parseFloat(val2 || 0)
      else if (dataId === 'date' || dataId === 'datetime') ret = (new Date(val1)).toISOString() === (new Date(val2)).toISOString()
      else ret = val1 === val2
    }
    else if (comp === '<>') {
      if (dataId.substring(0, 3) === 'sel') ret = val1.value !== val2.value //value
      else if (dataId.substring(0, 3) === 'cat' && (filter[k].dataId.includes('.'))) {
        const par = filter[k].dataId.split('.')
        const arr = item[par[0]] || []
        const idx = arr.findIndex(el => el[par[1]] === val2.id)
        ret = idx === -1
      }
      else if (dataId.substring(0, 3) === 'cat' && (!val1 || !val2)) ret = false //id
      else if (dataId.substring(0, 3) === 'cat') ret = val1.id !== val2.id //id
      else if (dataId === 'text') ret = val1.toLowerCase() !== val2.toLowerCase()
      else if (dataId === 'number' || dataId === 'number1' || dataId === 'number2' || dataId === 'number3') ret = parseFloat(val1 || 0) !== parseFloat(val2 || 0)
      else if (dataId === 'date' || dataId === 'datetime') ret = (new Date(val1)).toISOString() !== (new Date(val2)).toISOString()
      else ret = val1 !== val2
    }
    else if (comp === 'lk') {
      if (!val1 && val2 && dataId !== 'selYN' && !filter[k].dataId.includes('.')) return false
      if (val1 && !val2) return true
      if (dataId === 'number' || dataId === 'number1' || dataId === 'number2' || dataId === 'number3') ret = ('' + val1).includes(('' + val2))
      else if (dataId.substring(0, 3) === 'cat' && (filter[k].dataId.includes('.'))) {
        const par = filter[k].dataId.split('.')
        const arr = item[par[0]] || []
        const idx = arr.findIndex(el => el[par[1].replace('_id', '')].toLowerCase().includes(((val2 || {}).name || val2 || '').toLowerCase()))
        ret = idx !== -1
      }
      else if (dataId.substring(0, 3) === 'cat' && typeof val1 === 'object') ret = ((val1 || {}).name || '').toLowerCase().includes(((val2 || {}).name || val2 || '').toLowerCase())
      else if (dataId.substring(0, 3) === 'cat') ret = ((val1 || {}).name || val1 || '').toLowerCase().includes(((val2 || {}).name || val2 || '').toLowerCase())
      else if (dataId === 'selYN') ret = parseInt(val1 || 0) === parseInt(val2)
      else if (dataId.substring(0, 3) === 'sel') ret = ('' + ((val1 || {}).name || val1) || '').toLowerCase().includes(((val2 || {}).name || val2 || '').toLowerCase())
      else if (dataId === 'date' || dataId === 'datetime') ret = (new Date(val1)).toLocaleString().includes(val2.toLowerCase())
      else ret = val1.toLowerCase().includes(val2.toLowerCase())
    }
    else if (comp === 'nlk') {
      ret = !val1.toLowerCase().includes(val2.toLowerCase())
    }
    else if (comp === '>') {
      if (dataId === 'number' || dataId === 'number1' || dataId === 'number2' || dataId === 'number3') ret = parseFloat(val1 || 0) > parseFloat(val2)
      else if (dataId === 'date' || dataId === 'datetime') ret = (new Date(val1)).toISOString() > (new Date(val2)).toISOString()
      else ret = val1 > val2
    }
    else if (comp === '<') {
      if (dataId === 'number' || dataId === 'number1' || dataId === 'number2' || dataId === 'number3') ret = parseFloat(val1 || 0) < parseFloat(val2)
      else if (dataId === 'date' || dataId === 'datetime') ret = (new Date(val1)).toISOString() < (new Date(val2)).toISOString()
      else ret = val1 < val2
    }
    else if (comp === 'btw') {
      ret = (new Date(val1)).toISOString() < (new Date(val2)).toISOString()
    }
    else if (comp === 'in_f') {
      const pid = val1?.pid || null
      ret = pid === (val2.id || '9999')
      if (!ret) {
        const idx = (val2.data || []).findIndex(el => el.id === pid)
        ret = idx !== -1
      }
    }
    else if (comp === 'nin_f') {
      const pid = val1.pid || null
      ret = pid !== (val2.id || '9999')
      if (!ret) {
        const idx = (val2.data || []).findIndex(el => el.id === pid)
        ret = idx === -1
      }
    }
    else {
      ret = false
    }
    if (!ret) break
  }

  return ret
}

export const exportToExcel = async (wndData) => {
  if (!wndData?.content) return;
  const { caption, headcol, data, data1, data2, headcol1, headcol2 } = wndData.content;

  const headers = headcol ? [headcol] : [];
  //const headers2 = headcol ? [headcol] : [];
  let rows = [];
  let rows2 = [];
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet(data1 ? 'Випуск продукції' : "Звіт");

  switch (true) {
    case caption.toLowerCase().includes("звіт з поступлень за період"):
      headers.push("Кількість", "Сума");
      rows = data.map(el => [
        el.level > 0 ? `${" ".repeat(el.level * 4)}${el.name}` : el.name,
        el.qtt?.toFixed(3),
        el.am?.toFixed(2),
      ]);
      break;

    case caption.toLowerCase().includes("звіт по заборгованості"):
      headers.push('Коментар', 'Борг на початок', 'Прихід', 'Оплата', 'Борг на кінець');
      rows = data.map(el => [
        el.level > 0 ? `${" ".repeat(el.level * 4)}${el.name}` : el.name,
        el.note,
        el.sum_s?.toFixed(2),
        el.sum_d?.toFixed(2),
        el.sum_c?.toFixed(2),
        (el.sum_s + el.sum_d - el.sum_c)?.toFixed(2)
      ]);
      break;

    case caption.toLowerCase().includes("звіт про залишки"): {
      sheet.addRow([caption]);
      const captionRow = sheet.getRow(1);
      captionRow.font = { size: 14, bold: true };
      sheet.mergeCells(1, 1, 1, 9);
      captionRow.alignment = { horizontal: "center" };

      // === Двохрівневий заголовок ===
      const headerRow1 = [
        headcol || "Товар",
        "Залишок на початок", "",
        "Прихід", "",
        "Розхід", "",
        "Залишок на кінець", "",
      ];

      const headerRow2 = [
        "",
        "Кількість", "Сума",
        "Кількість", "Сума",
        "Кількість", "Сума",
        "Кількість", "Сума",
      ];

      sheet.addRow(headerRow1);
      sheet.addRow(headerRow2);

      sheet.mergeCells("A2:A3");
      sheet.mergeCells("B2:C2");
      sheet.mergeCells("D2:E2");
      sheet.mergeCells("F2:G2");
      sheet.mergeCells("H2:I2");

      [2, 3].forEach((r) => {
        const row = sheet.getRow(r);
        row.font = { bold: true, color: { argb: "FFFFFFFF" } };
        row.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF7A41BF" },
        };
        row.alignment = { horizontal: "center", vertical: "middle" };
      });

      const rows = data.map((el) => {
        let qtt_s = el.qtt_s ? el.qtt_s.toFixed(3) : "";
        let sum_s = el.sum_s ? el.sum_s.toFixed(2) : "";
        const qtt_d = el.qtt_d ? el.qtt_d.toFixed(3) : "";
        const sum_d = el.sum_d ? el.sum_d.toFixed(2) : "";
        const qtt_c = el.qtt_c ? el.qtt_c.toFixed(3) : "";
        const sum_c = el.sum_c ? el.sum_c.toFixed(2) : "";

        let qtt_f = el.qtt_s + el.qtt_d - el.qtt_c
          ? (el.qtt_s + el.qtt_d - el.qtt_c).toFixed(3)
          : "";
        let sum_f = el.sum_s + el.sum_d - el.sum_c
          ? (el.sum_s + el.sum_d - el.sum_c).toFixed(2)
          : "";

        if (el.type2 === "catalog") {
          qtt_f = sum_f = qtt_s = sum_s = "";
        }

        return [
          el.level > 0 ? `${" ".repeat(el.level * 4)}${el.name}` : el.name,
          qtt_s, sum_s, qtt_d, sum_d, qtt_c, sum_c, qtt_f, sum_f,
        ];
      });

      rows.forEach((r) => sheet.addRow(r));

      sheet.eachRow((row, rowNumber) => {
        if (rowNumber > 3) {
          for (let colIndex = 2; colIndex <= 9; colIndex++) {
            const cell = row.getCell(colIndex);
            const value = parseFloat(cell.value);
            if (!isNaN(value) && value < 0) {
              cell.font = { color: { argb: "FFFF0000" } };
            }
          }
        }
      });

      sheet.columns.forEach((col, i) => {
        col.width = i === 0 ? 40 : 14;
      });
      break;
    }

    case caption.toLowerCase().includes("звіт по калькуляціях"):
      headers.push("Кількість", "Нетто");
      rows = data.map(el => [
        el.level > 0 ? `${" ".repeat(el.level * 4)}${el.name}` : el.name,
        el.qtt?.toFixed(4),
        el.nt?.toFixed(0),
      ]);
      break;

    case caption.toLowerCase().includes("звіт по боржниках"):
      headers.push("Борг на початок	", "Прихід", "Оплата", "На кінець");
      rows = data.map(el => [
        el.level > 0 ? `${" ".repeat(el.level * 4)}${el.name}` : el.name,
        el.sum_s?.toFixed(2),
        el.sum_d?.toFixed(2),
        el.sum_c?.toFixed(2),
        (el.sum_s + el.sum_d - el.sum_c)?.toFixed(2)
      ]);
      break;

    case caption.toLowerCase().includes("звіт про рух коштів"):
      headers.push("Залишок на початок", "Прихід", "Розхід", "Залишок на кінець");
      rows = data.map(el => [
        el.level > 0 ? `${" ".repeat(el.level * 4)}${el.name}` : el.name,
        el.sum_s?.toFixed(2),
        el.sum_d?.toFixed(2),
        el.sum_c?.toFixed(2),
        (el.sum_s + el.sum_d - el.sum_c)?.toFixed(2)
      ]);
      break;

    case caption.toLowerCase().includes("звіт по переробках за період"):
      headers.push("Найменування", "Кількість", "Витрати", "%", "Вартість");
      rows = data.map(el => [
        el.level > 0 ? `${" ".repeat(el.level * 4)}${el.name}` : el.name,
        el.sum_s?.toFixed(2) ?? "",
        el.sum_d?.toFixed(2) ?? "",
        el.sum_c?.toFixed(2) ?? "",
        el.sum_v?.toFixed(2) ?? "",
      ]);
      break;

    case caption.toLowerCase().includes("звіт по продажах"):
      headers.push("Кількість", "Сума", "Знижка", "Вартість", "Прибуток");
      rows = data.map(el => [
        el.level > 0 ? `${" ".repeat(el.level * 4)}${el.name}` : el.name,
        el.qtt?.toFixed(2) ?? "",
        el.am?.toFixed(2) ?? "",
        el.dsc?.toFixed(2) ?? "",
        el.cst?.toFixed(2) ?? "",
        ((el.am ?? 0) - (el.cst ?? 0)).toFixed(2),
      ]);
      break;

    case caption.toLowerCase().includes("звіт по відмовах"):
      headers.push("Кількість",
        "Сума",
        "Знижка",
        "Вартість",
        "Прибуток",);
      rows = data.map((el) => [
        el.level > 0 ? (`${" ".repeat(el.level * 4)}${el.name}`) : (el.name),
        el.qtt?.toFixed(3),
        el.am?.toFixed(2),
        el.dsc?.toFixed(2),
        el.cst?.toFixed(2),
        (el.am - el.cst)?.toFixed(2),
      ]);
      break;

    case caption.toLowerCase().includes("звіт про випуск продукції"):
      //console.log(wndData.content.data1)
      headers.push("Продукція", "Підрозділ", "Кількість", "Сума");
      rows = wndData.content.data1.map((el) => [
        el.prod_name ?? "",
        el.dep_name ?? "",
        el.qtt ? el.qtt.toFixed(3) : "",
        el.am ? el.am.toFixed(2) : "",
      ]);
      break;

    case caption.toLowerCase().includes("звіт по доставках"):
      headers.push("Засовлень",
        "Сума",
        "Доставка",
        "Винагорода");
      rows = data.map((el) => [
        el.level > 0 ? (`${" ".repeat(el.level * 4)}${el.name}`) : (el.name),
        el.qtt?.toFixed(3),
        el.am?.toFixed(2),
        el.dsc?.toFixed(2),
        el.cst?.toFixed(2),
      ]);
      break;

    case caption.includes("Фінансовий звіт про прибутки та збитки (P&L)"):
      headers.push("Стаття", headcol1, headcol2);
      let openState = true;

      rows = data
        .filter(el => {

          if (el.level === 1 && el.open !== undefined) {
            openState = el.open;
            return true;
          }

          if (el.level > 1) {
            return openState;
          }

          return true;
        })
        .map(el => [
          el.level > 0
            ? `${" ".repeat(el.level * 4)}${el.name}`
            : el.name,
          el.am1?.toFixed(4),
          el.am2?.toFixed(0),
        ]);
      break;

    default:
      headers.push("Значення 1", "Значення 2");
      rows = data.map(el => [
        el.level > 0 ? `${" ".repeat(el.level * 4)}${el.name}` : el.name,
        el.val1?.toFixed(2),
        el.val2?.toFixed(2),
      ]);
  }

  if (!caption.toLowerCase().includes("звіт про залишки")) {
    sheet.addRow([caption]);
    const captionRow = sheet.getRow(1);
    captionRow.font = { size: 14, bold: true };
    sheet.mergeCells(1, 1, 1, headers.length);
    captionRow.alignment = { horizontal: "center" };

    sheet.addRow(headers);
    const headerRow = sheet.getRow(2);
    headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
    headerRow.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF7A41BF" },
    };
  }

  if (data2 && data2.length > 0) {
    const sheet2 = workbook.addWorksheet('Витрата інгредієнтів');

    sheet2.addRow([caption]);
    sheet2.getRow(1).font = { size: 14, bold: true };

    const headers2 = [headcol || "Інгредієнт", "Підрозділ", "Кількість", "Сума"];
    sheet2.mergeCells(1, 1, 1, headers2.length);
    sheet2.getRow(1).alignment = { horizontal: "center" };

    const hRow2 = sheet2.addRow(headers2);
    hRow2.font = { bold: true, color: { argb: "FFFFFFFF" } };
    hRow2.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF7A41BF" } };

    data2.forEach(el => {
      sheet2.addRow([
        el.good_name ?? "",
        el.dep2_name ?? "",
        el.qtt ? el.qtt.toFixed(3) : "",
        el.am ? el.am.toFixed(2) : "",
      ]);
    });

    sheet2.columns.forEach((col, i) => {
      col.width = i === 0 ? 50 : 15;
    });
  }

  rows.forEach((r) => sheet.addRow(r));
  rows2.forEach((r) => sheet.addRow(r));

  //const lastRowIndex = sheet.rowCount;
  sheet.eachRow((row, rowNumber) => {
    if (rowNumber > 2) {
      for (let colIndex = 2; colIndex <= headers.length; colIndex++) {
        const cell = row.getCell(colIndex);
        const value = parseFloat(cell.value);

        if (!isNaN(value) && value < 0) {
          cell.font = { bold: true, color: { argb: "FFFF0000" } };
        }
      }

    }
  });

  sheet.columns.forEach((col, i) => {
    col.width = i === 0 ? 50 : 15;
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "report.xlsx");
};

export const exportToExcelRep = async (wndData, catGoods) => {
  if (!wndData) return;
  const { id, type, date, table, dep_from, department, department2, counterpartie } = wndData

  const headers = []
  let caption = ''
  let subText1 = ''
  let sender = ''
  let subText2 = ''
  let recipient = ''
  let rows = []
  let rows2 = []

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Звіт");

  switch (true) {
    case type === 'docReject':
      caption = `Видаткова накладна (повернення) № ${id} від ${new Date(date).toLocaleDateString('uk-UA')}`
      subText1 = 'Відправник'
      sender = 'Cocktail'
      subText2 = 'Отримувач'
      recipient = counterpartie.name
      headers.push("№ п/п", 'Назва', 'Кількість', 'Од.', 'Ціна', 'Сума');

      rows = table.map((el, index) => [
        index + 1,
        el.good,
        el.qtt,
        units[el.unit],
        el.price,
        el.amount,
      ]);

      rows.push(["Разом", '', '', '', '', wndData.sum])
      break;

    case type === "docTransfer":
      caption = `Видаткова накладна (переміщення) № ${id} від ${new Date(date).toLocaleDateString('uk-UA')}`
      subText1 = 'Відправник'
      sender = 'Cocktail'
      subText2 = 'Отримувач'
      recipient = dep_from.name
      headers.push("№ п/п", 'Назва', 'Кількість', 'Од.', 'Ціна', 'Сума');

      rows = table.map((el, index) => [
        index + 1,
        el.good,
        el.qtt,
        units[el.unit],
        el.price,
        el.amount,
      ]);

      rows.push(["Разом", '', '', '', '', wndData.sum])
      break;

    case type === "docExpence":
      caption = `АКТ списання № ${id} від ${new Date(date).toLocaleDateString('uk-UA')}`
      subText1 = 'Підрозділ'
      sender = department.name
      subText2 = 'Стаття'
      headers.push("№ п/п", 'Назва', 'Кількість', 'Од.', 'Ціна', 'Сума');

      rows = table.map((el, index) => [
        index + 1,
        el.good,
        el.qtt,
        units[el.unit],
        el.price,
        el.amount,
      ]);

      rows.push(["Разом", '', '', '', '', wndData.sum])
      break;

    case type === "docRevision":
      caption = `Акт інвентаризації цінностей станом на ${new Date(date).toLocaleDateString('uk-UA')}`
      subText1 = 'Пірозділ'
      sender = `${department.name} ${department2.name ? `, ${department2.name}` : ''} `
      subText2 = 'Стаття'

      let sum = 0
      let sum2 = 0
      let sum3 = 0
      let sum4 = 0
      let sum5 = 0

      if (!catGoods) return

      rows = table.map((el, index) => {


        //if (!catGoods) return null
        const good = catGoods.find(i => i.id === el.good_id)
        let sum_prc = parseFloat(good.sum_in ?? 0)

        const qtt_a = Math.round(parseFloat(el.qtt_a || 0) * 1000) / 1000
        const sum_a = qtt_a * sum_prc
        const qtt_f = Math.round(parseFloat(el.qtt_f || 0) * 1000) / 1000
        const qtt_p = Math.round(parseFloat(el.qtt_p || 0) * 1000) / 1000
        const sum_f = (qtt_f + qtt_p) * sum_prc
        const qtt_r = Math.round((qtt_f + qtt_p - qtt_a) * 1000) / 1000
        if (good.price_history) sum_prc = parseFloat(getIrgValue(wndData.date, good.price_history) || 0)

        sum += Number(qtt_f)
        sum2 += Number(sum_f.toFixed(2))
        sum3 += Number(qtt_a)
        sum4 += Number((qtt_r > 0 ? '+' + qtt_r : qtt_r))
        sum5 += Number(sum_f.toFixed(2))

        if (Number(el.good_type) > 1 && parseFloat(el.qtt_f || 0) + parseFloat(el.qtt_p || 0) === parseFloat(el.qtt_a || 0)) {
          rows2.push([
            el.good,
            units[el.unit],
            Math.round(parseFloat(el.qtt_f || 0) * 1000) / 1000,
            Math.round((qtt_f - qtt_a) * 1000) / 1000
          ])
          return undefined
        } else {
          return [
            el.good,
            units[el.unit],
            qtt_f,
            qtt_p,
            sum_f.toFixed(2),
            qtt_a,
            (sum_f - sum_a).toFixed(2),
            qtt_r > 0 ? '+' + qtt_r : qtt_r,
            sum_f.toFixed(2)
          ]
        }
      });

      rows.push(["Усього", '', sum, '', sum2, sum3, '', sum4 > 0 ? `+${sum4}` : sum4, sum5])
      break;

    case type === "docSalary":
      caption = `Розрахунково-платіжна відомість № ${id} від ${new Date(date).toLocaleDateString('uk-UA')}`

      rows = table.map((el, index) => [
        el.employee,
        el.days || 0,
        el.hours || 0,
        el.sum_m || 0,
        el.sum_d || 0,
        el.sum_h || 0,
        el.amount_a || 0,
        el.sum_a || 0,
        el.amount_d1 || 0,
        el.sum_d1 || 0,
        el.amount_d2 || 0,
        el.sum_d2 || 0,
        el.amount_t || 0,
        el.sum_t || 0,
        el.bonus || 0,
        el.sick || 0,
        el.vacation || 0,
        el.totall || 0,
        el.tax_base || 0,
        el.inc_tax || 0,
        el.mil_tax || 0,
        el.esv || 0,
        el.taxes || 0,
        el.amount || 0,
      ]);
      break;
    
  default:
      break;

  }

  sheet.mergeCells('C2:H2');
  sheet.getCell('C2').value = caption;
  sheet.getCell('C2').font = { bold: true, color: { argb: 'FF000000' } };
  sheet.getCell('C2').alignment = { horizontal: 'center' };

  sheet.getCell('B4').value = subText1;
  sheet.getCell('C4').value = sender;
  sheet.getCell('C4').font = { bold: true };

  sheet.getCell('B5').value = subText2;
  sheet.getCell('C5').value = recipient;
  type !== "docSalary" && (sheet.getCell('C5').font = { bold: true });

  if (type === "docSalary") {
    sheet.mergeCells('A6:A7');
    sheet.mergeCells('B6:B7');
    sheet.mergeCells('C6:D6');

    sheet.mergeCells('E6:S6');
    sheet.mergeCells('T6:X6');
    sheet.mergeCells('Y6:Y7');

    sheet.getCell('C6').value = 'Відпрацьовано';
    sheet.getCell('E6').value = 'Нараховано за видами виплат';
    sheet.getCell('T6').value = 'Утримано та враховано';

    ['C6', 'E6', 'T6', 'W6'].forEach(cell => {
      sheet.getCell(cell).alignment = {
        horizontal: 'center',
        vertical: 'middle'
      };
    });

    sheet.getCell('A7').value = '№ п/п';
    sheet.getCell('B7').value = 'Працівник';
    sheet.getCell('C7').value = 'Днів';
    sheet.getCell('D7').value = 'Годин';
    sheet.getCell('E7').value = 'Нараховано оклад';
    sheet.getCell('F7').value = 'Поденно';
    sheet.getCell('G7').value = 'Погодинно';
    sheet.getCell('H7').value = 'Виручка';
    sheet.getCell('I7').value = 'Нараховано';
    sheet.getCell('J7').value = 'Виручка підрозділа';
    sheet.getCell('K7').value = 'Нараховано';
    sheet.getCell('L7').value = 'Виручка підрозділа';
    sheet.getCell('M7').value = 'Нараховано';
    sheet.getCell('N7').value = 'Загальна виручка закладу';
    sheet.getCell('O7').value = 'Нараховано';
    sheet.getCell('P7').value = 'Премія';
    sheet.getCell('Q7').value = 'Лікарняні';
    sheet.getCell('R7').value = 'Відпускні';
    sheet.getCell('S7').value = 'Разом нараховано';
    sheet.getCell('T7').value = 'База для податків';
    sheet.getCell('U7').value = 'ПДФО';
    sheet.getCell('V7').value = 'Військовий збір';
    sheet.getCell('W7').value = 'ЄСВ';
    sheet.getCell('X7').value = 'Разом податки';
    sheet.getCell('Y7').value = 'До виплати';
  } else if (type === "docRevision") {
    const r1 = 7;
    const r2 = 8;

    sheet.mergeCells(`A${r1}:A${r2}`);
    sheet.mergeCells(`B${r1}:B${r2}`);
    sheet.mergeCells(`C${r1}:C${r2}`);

    sheet.mergeCells(`D${r1}:F${r1}`);
    sheet.mergeCells(`G${r1}:H${r1}`);
    sheet.mergeCells(`I${r1}:J${r1}`);

    const centeredCells = [`D${r1}`, `G${r1}`, `I${r1}`];

    centeredCells.forEach(ref => {
      const cell = sheet.getCell(ref);
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true // додаємо перенос, якщо текст довгий
      };
    });

    sheet.getCell(`A${r1}`).value = '№ п/п';
    sheet.getCell(`B${r1}`).value = 'Назва';
    sheet.getCell(`C${r1}`).value = 'Од.';
    sheet.getCell(`D${r1}`).value = 'Фактично виявлено перевіркою';
    sheet.getCell(`G${r1}`).value = 'Значиться по даних обліку';
    sheet.getCell(`I${r1}`).value = 'Результати перевірки (+ більше, - менше)';

    sheet.getCell(`D${r2}`).value = 'К-сть';
    sheet.getCell(`E${r2}`).value = 'У прод.';
    sheet.getCell(`F${r2}`).value = 'Сума';
    sheet.getCell(`G${r2}`).value = 'К-сть';
    sheet.getCell(`H${r2}`).value = 'Сума';
    sheet.getCell(`I${r2}`).value = 'К-сть';
    sheet.getCell(`J${r2}`).value = 'Сума';
  } else {
    sheet.getRow(7).values = headers;
  }

  rows
    .filter(row => Array.isArray(row) && row.length > 0)
    .forEach((row, index) => {
      const rowNumber = (type === "docRevision") ? 9 + index : 8 + index;
      sheet.getRow(rowNumber).values = [index + 1, ...row];
    });

  type !== "docSalary" && (sheet.getRow(sheet.lastRow.number).font = { bold: true });

  if (rows2.length) {
    const lastRowNumber = sheet.lastRow.number + 1;

    const headerRow = sheet.getRow(lastRowNumber + 2);
    sheet.mergeCells(`B${lastRowNumber}:E${lastRowNumber}`);
    headerRow.getCell(3).value = "Продукція та напівфабрикати перераховані в інгредієнти";
    headerRow.getCell(3).font = { bold: true };
    headerRow.getCell(3).alignment = { horizontal: 'center' };

    rows2.forEach((row, i) => {
      sheet.addRow([i + 1, ...row]);
    });
  }

  sheet.columns.forEach(column => {
    let maxLength = 0;

    column.eachCell({ includeEmpty: true }, (cell, rowNumber) => {
      if (rowNumber < 3) return;

      const val = cell.value ? cell.value.toString() : '';
      maxLength = Math.max(maxLength, val.length);
    });

    column.width = maxLength + 2;
  });

  const targetRow = sheet.lastRow.number + 2;

  const makeSignCell = (range, text) => {
    sheet.mergeCells(range);

    const cell = sheet.getCell(range.split(':')[0]);
    cell.value = text;
    cell.alignment = { horizontal: 'center' };
    cell.border = { top: { style: 'thin' } };
  };

  if (type === "docExpence") {
    sheet.getCell(`A${targetRow}`).value = 'Голова комісії';
    const r = targetRow + 1;

    makeSignCell(`C${r}:D${r}`, '(посада)');
    makeSignCell(`F${r}:G${r}`, '(Підпис)');
    makeSignCell(`I${r}:K${r}`, "(прізвище, ім'я, по батькові)");

    sheet.getCell(`A${targetRow + 3}`).value = 'Члени комісії';
    const r2 = targetRow + 4;
    const r3 = targetRow + 6;
    const r4 = targetRow + 8;

    [r2, r3, r4].forEach(r => {
      makeSignCell(`C${r}:D${r}`, '(посада)');
      makeSignCell(`F${r}:G${r}`, '(Підпис)');
      makeSignCell(`I${r}:K${r}`, "(прізвище, ім'я, по батькові)");
    });

  } else if (wndData.type === 'docRevision') {
    sheet.getCell(`B${targetRow + 2}`).value = 'Підписи:';
    sheet.getCell(`B${targetRow + 3}`).value = "особа, яка проводила контрольну перевірку:";
    sheet.getCell(`C${targetRow + 3}`).value = "__________";

    sheet.getCell(`B${targetRow + 4}`).value = "голова інвентаризаційної комісії:";
    sheet.getCell(`C${targetRow + 4}`).value = "__________";

    sheet.getCell(`B${targetRow + 5}`).value = "члени інвентаризаційної комісії:";
    sheet.getCell(`C${targetRow + 5}`).value = "__________";
    sheet.getCell(`C${targetRow + 6}`).value = "__________";
    sheet.getCell(`C${targetRow + 7}`).value = "__________";
  } else if (type === "docExpence" || type === "docTransfer" || type === "docReject") {
    sheet.getCell(`B${targetRow}`).value = 'Відпустив:';
    sheet.getCell(`CF${targetRow}`).value = 'Прийняв:';
  } else if (type === "docSalary") {
    sheet.mergeCells(`A${targetRow + 1}:B${targetRow + 1}`);
    sheet.getCell(`A${targetRow + 1}`).value = 'Начальник підрозділу:';
    sheet.getCell(`C${targetRow + 1}`).value = '___________________________';
    sheet.getCell(`C${targetRow + 2}`).value = "(прізвище, ім'я, по батькові)";

    sheet.getCell(`E${targetRow + 1}`).value = 'Головний бухгалтер:';
    sheet.getCell(`F${targetRow + 1}`).value = '___________________________';
    sheet.getCell(`F${targetRow + 2}`).value = "(прізвище, ім'я, по батькові)";
  }

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "report.xlsx");
}

export const exportCalculationToExcel = async (wndData, catGoods) => {
  if (!wndData || wndData.type !== 'docCalculation') return;
  const myData = Array.isArray(wndData.arrData) ? wndData.arrData : [wndData]

  const workbook = new ExcelJS.Workbook();

  myData.forEach((data) => {
    const dinamicSheet = workbook.addWorksheet(`Страва №${data.id}`);
    const good = catGoods.find((i) => i.id === data.good.id)
    const allergensOfGood = good.allergens ? good.allergens.split(',').map(el => ' ' + allAllergens.find(it => it.idx === el).name) : []
    const dinamicRows = []
    let acc = 0;
    let acc1 = 0;
    console.log(good)
    if (wndData.prn_type === 1) {
      data.table.forEach((d, index) => {
        acc += Math.round(parseFloat(d.netto || 0));
        acc1 += Math.round(parseFloat(d.netto || 0) / parseFloat(data.qtt || 1));
        dinamicRows.push([
          index + 1,
          d.good,
          `${parseFloat(d.qtt || 0)}${units[d.unit]}`,
          Math.round(parseFloat(d.netto || 0)),
          Math.round(d.qtt / parseFloat(data.qtt || 1) * 1000) / 1000,
          Math.round(parseFloat(d.netto || 0) / parseFloat(data.qtt || 1))
        ])
      })

      dinamicSheet.getCell(`G1`).value = '"Затверджую"';
      dinamicSheet.getCell(`G2`).value = '____________';
      dinamicSheet.getCell(`G3`).value = '____________';

      dinamicSheet.mergeCells(`B3:E3`);
      dinamicSheet.getCell(`B3`).value = `Технологічна карта №${data.id} від ${new Date(data.date).toLocaleDateString('uk-UA')}`;
      dinamicSheet.getCell('B3').font = { bold: true, color: { argb: 'FF000000' } };
      dinamicSheet.getCell('B3').alignment = { horizontal: 'center' };

      dinamicSheet.mergeCells(`B5:E5`);
      dinamicSheet.getCell(`B5`).value = `${data.good.name}`;
      dinamicSheet.getCell('B5').font = { bold: true, color: { argb: 'FF000000' } };
      dinamicSheet.getCell('B5').alignment = { horizontal: 'center' };

      dinamicSheet.mergeCells(`B6:E6`);
      dinamicSheet.getCell(`B6`).value = `(найменування страви)`;
      dinamicSheet.getCell('B6').alignment = { horizontal: 'center' };
      dinamicSheet.getCell(`B6`).font = {
        name: 'Arial',
        size: 9
      };

      dinamicSheet.getCell(`B6`).border = {
        top: {
          style: 'thin',
          color: { argb: '000000' }
        }
      };

      dinamicSheet.mergeCells(`A8:A9`);
      dinamicSheet.mergeCells(`B8:B9`);
      dinamicSheet.mergeCells(`C8:D8`);
      dinamicSheet.mergeCells(`E8:F8`);
      dinamicSheet.mergeCells(`G8:H9`);

      dinamicSheet.getCell(`A8`).value = `№ п/п`;
      dinamicSheet.getCell(`B8`).value = `Найменування сировини`;
      dinamicSheet.getCell(`C8`).value = `Норма вмісту сировини в готовій страві`;
      dinamicSheet.getCell(`E8`).value = `Норма вмісту в 1 порції`;
      dinamicSheet.getCell(`G8`).value = `Технологічні вимоги до якості сировини`;

      dinamicSheet.getCell(`C9`).value = `Бруто`;
      dinamicSheet.getCell(`D9`).value = `Нетто, в грамах`;
      dinamicSheet.getCell(`E9`).value = `Бруто`;
      dinamicSheet.getCell(`F9`).value = `Нетто, в грамах`;

      dinamicRows.forEach((d) => {
        dinamicSheet.addRow(d)
      })

      dinamicSheet.mergeCells(`G10:H${data.table.length + 10}`);
      dinamicSheet.getCell(`G10`).value = `Вимоги до якості та безпеки вказані у специфікації сировини`;

      dinamicSheet.getCell(`A${dinamicSheet.lastRow.number}`).value = `Всього`;
      dinamicSheet.getCell(`D${dinamicSheet.lastRow.number}`).value = acc;
      dinamicSheet.getCell(`F${dinamicSheet.lastRow.number}`).value = acc1;

      if (data.qtt > 1) {
        dinamicSheet.getCell(`A${dinamicSheet.lastRow.number + 1}`).value = `Вихід готової страви на ${data.qtt} ${units[data.good.unit.value]}`;
        dinamicSheet.getCell(`B${dinamicSheet.lastRow.number}`).value = Number(data.netto) ? data.netto : '0';
      }

      dinamicSheet.getCell(`A${dinamicSheet.lastRow.number + 1}`).value = `Вихід готової страви на 1 ${units[data.good.unit.value]}`;
      dinamicSheet.getCell(`B${dinamicSheet.lastRow.number}`).value = Number(data.netto) ? data.qtt / data.netto : '0';

      dinamicSheet.mergeCells(`A${dinamicSheet.lastRow.number + 2}:D${dinamicSheet.lastRow.number + 2}`);
      dinamicSheet.getCell(`A${dinamicSheet.lastRow.number}`).value = "Наявність харчових алергенів у страві: ";
      dinamicSheet.getCell(`A${dinamicSheet.lastRow.number}`).font = { bold: true, color: { argb: 'FF000000' } };

      dinamicSheet.getCell(`E${dinamicSheet.lastRow.number}`).value = allergensOfGood.length ? allergensOfGood.join(',') : "алергени відсутні";

      if (good.proteins || good.fat || good.energy || good.carbohydrate) {
        dinamicSheet.mergeCells(`B${dinamicSheet.lastRow.number + 2}:E${dinamicSheet.lastRow.number + 2}`);
        dinamicSheet.getCell(`B${dinamicSheet.lastRow.number}`).value = "Харчова та енергетична цінність одної порції";
        dinamicSheet.getCell(`B${dinamicSheet.lastRow.number}`).font = { bold: true, color: { argb: 'FF000000' } };
        dinamicSheet.getCell(`B${dinamicSheet.lastRow.number}`).alignment = { horizontal: 'center' };

        if (good.proteins) {
          dinamicSheet.getCell(`B${dinamicSheet.lastRow.number + 1}`).value = 'Білки:'
          dinamicSheet.getCell(`B${dinamicSheet.lastRow.number}`).font = { bold: true, color: { argb: 'FF000000' } }
          dinamicSheet.getCell(`C${dinamicSheet.lastRow.number}`).value = `${good.proteins} г`
        };

        if (good.fat) {
          dinamicSheet.getCell(`B${dinamicSheet.lastRow.number + 1}`).value = 'Жири:'
          dinamicSheet.getCell(`B${dinamicSheet.lastRow.number}`).font = { bold: true, color: { argb: 'FF000000' } }
          dinamicSheet.getCell(`C${dinamicSheet.lastRow.number}`).value = `${good.fat} г`
        };

        if (good.carbohydrate) {
          dinamicSheet.getCell(`B${dinamicSheet.lastRow.number + 1}`).value = 'Вуглеводи:'
          dinamicSheet.getCell(`B${dinamicSheet.lastRow.number}`).font = { bold: true, color: { argb: 'FF000000' } }
          dinamicSheet.getCell(`C${dinamicSheet.lastRow.number}`).value = `${good.carbohydrate} г`
        };

        if (good.energy) {
          dinamicSheet.getCell(`B${dinamicSheet.lastRow.number + 1}`).value = 'Енергетична цінність:'
          dinamicSheet.getCell(`B${dinamicSheet.lastRow.number}`).font = { bold: true, color: { argb: 'FF000000' } }
          dinamicSheet.getCell(`C${dinamicSheet.lastRow.number}`).value = `${good.energy} кКал`
        };
      }

      if (data.cooking) {
        dinamicSheet.mergeCells(`A${dinamicSheet.lastRow.number + 2}:D${dinamicSheet.lastRow.number + 2}`);
        dinamicSheet.getCell(`A${dinamicSheet.lastRow.number}`).value = "Технологія приготування страви";
        dinamicSheet.getCell(`A${dinamicSheet.lastRow.number}`).font = { bold: true, color: { argb: 'FF000000' } };
        dinamicSheet.getCell(`A${dinamicSheet.lastRow.number}`).alignment = { horizontal: 'center' };

        dinamicSheet.mergeCells(`A${dinamicSheet.lastRow.number + 1}:H${dinamicSheet.lastRow.number + 5}`);
        dinamicSheet.getCell(`A${dinamicSheet.lastRow.number}`).value = data.cooking
      }


      dinamicSheet.getCell(`A${dinamicSheet.lastRow.number + 2}`).value = "Зав.виробництвом:";
      dinamicSheet.getCell(`B${dinamicSheet.lastRow.number}`).value = "________";
      dinamicSheet.getCell(`D${dinamicSheet.lastRow.number}`).value = "Калькуляцію склав:";
      dinamicSheet.getCell(`E${dinamicSheet.lastRow.number}`).value = "________";
    } else if (wndData.prn_type === 2) {
      dinamicSheet.mergeCells(`A1:B1`);
      dinamicSheet.getCell(`A1`).value = data.good.name;
      dinamicSheet.getCell(`A1`).font = { bold: true, color: { argb: 'FF000000' } };
      dinamicSheet.getCell(`A2`).value = `Кількість виробу:`;
      dinamicSheet.getCell(`B2`).value = `${data.qtt} шт`;
      dinamicSheet.getCell('B2').font = { bold: true, color: { argb: 'FF000000' } };

      dinamicSheet.mergeCells(`D1:E1`);
      dinamicSheet.getCell(`D1`).value = `Калькуляційна картка №${data.id} від ${new Date(data.date).toLocaleDateString('uk-UA')}`;
      dinamicSheet.getCell('D1').font = { bold: true, color: { argb: 'FF000000' } };

      dinamicSheet.getCell(`D2`).value = `вихід нетто:`;
      dinamicSheet.getCell(`E2`).value = `вихід нетто:`;
      dinamicSheet.getCell(`E2`).value = `${data.qtt} ${units[data.good.unit.value]}`;
      dinamicSheet.getCell('E2').font = { bold: true, color: { argb: 'FF000000' } };

      dinamicSheet.addRow(['№ п/п', 'Найменування продуктів', 'Норма (бруто)', 'Нетто (г.)'])

      data.table.forEach((el, index) => {
        dinamicSheet.addRow([
          index + 1,
          el.good,
          `${el.qtt} ${units[el.unit]}`,
          el.netto
        ]);
      });
    } else {
      dinamicSheet.mergeCells(`D1:E1`);

      dinamicSheet.getCell(`D1`).value = "Додаток 2 до пункту 1.6 Методичних рекомендацій код за ДКУД 09003102";
      dinamicSheet.mergeCells(`A2:C2`);
      dinamicSheet.getCell(`A2`).value = `Калькуляційна картка №${data.id} від ${new Date(data.date).toLocaleDateString('uk-UA')}`;
      dinamicSheet.getCell(`A2`).font = { bold: true };
      dinamicSheet.getCell(`A4`).value = `Найменування страви`;
      dinamicSheet.getCell(`B4`).value = `${data.good.name}`;
      dinamicSheet.getCell('B4').font = { bold: true };

      dinamicSheet.mergeCells(`C4:D4`);
      dinamicSheet.getCell(`D4`).value = `Номер рецептури по збірнику`;
      dinamicSheet.getCell(`E4`).value = `_______`;

      dinamicSheet.addRow(['№ п/п', 'Найменування продуктів', 'Норма (бруто)', 'Нетто (г.)', "Ціна", "Сума"])

      data.table.forEach((el, index) => {
        const good = catGoods.find(el => el.id === data.good_id)
        const prc = parseFloat(el.sum_prc || good?.sum_in || 0)

        dinamicSheet.addRow([
          index + 1,
          el.good,
          `${el.qtt} ${units[el.unit]}`,
          el.netto,
          prc,
          prc * el.qtt
        ]);
      });

      dinamicSheet.getCell(`A${dinamicSheet.lastRow.number + 2}`).value = `Загальна вартість набору на ${data.qtt} шт`;
      dinamicSheet.getCell(`B${dinamicSheet.lastRow.number}`).value = parseFloat(data.qtt) || 1;

      dinamicSheet.getCell(`A${dinamicSheet.lastRow.number}`).value = `Загальна вартість одиниці виробу`;
      dinamicSheet.getCell(`B${dinamicSheet.lastRow.number}`).value = parseFloat(data.qtt) || 1;

      dinamicSheet.getCell(`A${dinamicSheet.lastRow.number}`).value = `Продажна ціна страви`;
      dinamicSheet.getCell(`B${dinamicSheet.lastRow.number}`).value = good.sum_out;

      dinamicSheet.getCell(`A${dinamicSheet.lastRow.number}`).value = `Вихід у готовому виді`;
      dinamicSheet.getCell(`B${dinamicSheet.lastRow.number}`).value = `${(parseFloat(data.netto) / (parseFloat(data.qtt) || 1)).toFixed(2)} г`;

      dinamicSheet.getCell(`A${dinamicSheet.lastRow.number + 2}`).value = "Зав.виробництвом:";
      dinamicSheet.getCell(`B${dinamicSheet.lastRow.number}`).value = "________";
      dinamicSheet.getCell(`D${dinamicSheet.lastRow.number}`).value = "Калькуляцію склав:";
      dinamicSheet.getCell(`E${dinamicSheet.lastRow.number}`).value = "________";
      dinamicSheet.getCell(`G${dinamicSheet.lastRow.number}`).value = "Затверджую:";
      dinamicSheet.getCell(`H${dinamicSheet.lastRow.number}`).value = "________";
    }
  })

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "report.xlsx");
}